import { WarningCircle } from "@phosphor-icons/react";
import { Banner, Button } from "@replicate/ui";
import { route } from "../../urls";
import CopyIconButton from "../copy-icon-button";

export default function RevealToken({
  name,
  tokenKey,
}: {
  name: string;
  tokenKey: string;
}) {
  const settingsUrl = route("account_api_token_settings");

  return (
    <div className="space-y-4">
      <Banner
        condensed
        severity="warning"
        raised
        icon={<WarningCircle weight="duotone" className="top-1 relative" />}
        description="This is the only time you'll be able to see this token. Copy it now
        and store it somewhere safe. You won't be able to see it again."
      />

      <div>
        <p className="mb-1">
          <span className="font-bold">Token:</span> {name}
        </p>
        <div className="flex items-center gap-2 border border-r8-gray-6 p-3">
          <code className="flex-1 break-all font-mono text-r8-sm">
            {tokenKey}
          </code>
          <div className="shrink-0">
            <CopyIconButton content={tokenKey} label="Copy token" />
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <Button render={<a href={settingsUrl}>Done</a>} />
      </div>
    </div>
  );
}
